module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcforearm1-803342fda28a023cfc78a45222697d9b.jpg";